import { getScaledEnergyLabelsColor } from '@/domains/productDiscovery/ProductPage/common/components/AddToCart/IndexLabels/util';
import type { Attribute } from '@/domains/productDiscovery/ProductPage/interfaces/Detail.common.model';

export const MIN_ENERGY_ATTRIBUTE_ID = 10939;
export const MAX_ENERGY_ATTRIBUTE_ID = 10938;
export const ENERGY_ATTRIBUTE_ID = 39;

interface ScaledEnergyLabel {
  energyLabels: { [p: string]: string };
  energyAttribute: { value: string; imageUrl?: string };
  isEuEnergyLabel: boolean;
}
export const useScaledEnergyLabels = (
  attributes?: Attribute[],
): ScaledEnergyLabel | undefined => {
  const energyAttribute = attributes?.find(
    (attribute) => attribute.id === ENERGY_ATTRIBUTE_ID,
  );
  const minEnergyAttribute = attributes?.find(
    (attribute) => attribute.id === MIN_ENERGY_ATTRIBUTE_ID,
  );
  const maxEnergyAttribute = attributes?.find(
    (attribute) => attribute.id === MAX_ENERGY_ATTRIBUTE_ID,
  );
  if (!(energyAttribute && minEnergyAttribute && maxEnergyAttribute)) {
    return undefined;
  }

  return {
    energyLabels: getScaledEnergyLabelsColor(
      minEnergyAttribute.value,
      maxEnergyAttribute.value,
    ),
    energyAttribute: {
      value: energyAttribute.value,
    },
    isEuEnergyLabel:
      maxEnergyAttribute.value === 'A' &&
      minEnergyAttribute.value === 'G' &&
      energyAttribute.value.length === 1 &&
      maxEnergyAttribute.value.localeCompare(energyAttribute.value) <= 0 &&
      minEnergyAttribute.value.localeCompare(energyAttribute.value) >= 0,
  };
};
